import { BookingInfo } from "./BookingInfo";
import { Flights } from "../Flight";
import { OfferRoomDetail } from "../OfferRoomDetail";
import { PaymentType } from "./PaymentType";
import { Person } from "./Person";
import { SpecialDealDetail } from "../SpecialDealDetail";
import TourOperator from "../TourOperator";

export interface QuickVacancy {
  status: {
    type: OfferStatusTypes;
    message: string;
  };
  tourOperatorInfo?: string;
  providerMessage: null;
  flights: Flights;
  personList: Person[];
  travelPriceSum: number;
  countPersons: number;
  giataObjectCode: string;
  additionalServices: string[];
  transactionId: string;
  bookingInfo: BookingInfo;
  tourOperator: TourOperator;
  softBooking: boolean;
  offerForLimitedMobility: boolean;
  availablePaymentTypes: PaymentType[];
  accomCode: null;
  roomCode: null;
  roomType: null;
  offerRoomDetails: OfferRoomDetail[];
  mealType: null;
  cancellationMessage: null;
  peakworkResponse: null;
  termsAndConditionsUrl: null;
  offerChanged: boolean;
  upsellingOffer: boolean;
  specialDealsDetails: SpecialDealDetail[] | null;
  transfer: boolean;
  isUpgrading: boolean;
  totalPrice: number;
  totalPriceBasicOption: number;
}

export enum OfferStatusTypes {
  AVAILABLE = "AVAILABLE",
  ON_REQUEST = "ON_REQUEST",
  TO_CONFIRM = "TO_CONFIRM",
  TOUROPERATOR_COMMUNICATION_ERROR = "TOUROPERATOR_COMMUNICATION_ERROR",
  NOT_AVAILABLE = "NOT_AVAILABLE",
  GDS_COMMUNICATION_ERROR = "GDS_COMMUNICATION_ERROR",
  INVALID_FLIGHT_DATA = "INVALID_FLIGHT_DATA",
  NO_VALID_PAYMENT_METHOD = "NO_VALID_PAYMENT_METHOD",
  XHR_ERROR = "XHR_ERROR",
  ERROR = "ERROR",
  SUCCESSFUL = "SUCCESSFUL",
  SOLDOUT = "SOLDOUT",
  FAILED_PRICE_CHANGE = "FAILED_PRICE_CHANGE",
  FAILED_SOLD_OUT = "FAILED_SOLD_OUT",
  FAILED_FAULTY_DATA = "FAILED_FAULTY_DATA",
  FAILED_BOOKING_ALREADY_EXISTS = "FAILED_BOOKING_ALREADY_EXISTS",
  BOOKED_ON_OPTION = "BOOKED_ON_OPTION",
  GDS_UNKNOWN_STATUS = "GDS_UNKNOWN_STATUS",
  BOOKED = "BOOKED",
  BOOKED_RQ = "BOOKED_RQ",
  BOOKED_SOFT = "BOOKED_SOFT",
  BOOKED_UNDEFINED = "BOOKED_UNDEFINED",
  OFFER_NOT_MATCHED_WITH_REQUESTED_HOTEL = "OFFER_NOT_MATCHED_WITH_REQUESTED_HOTEL",
}

export const availableStatuses: OfferStatusTypes[] = [
  OfferStatusTypes.AVAILABLE,
  OfferStatusTypes.ON_REQUEST,
  OfferStatusTypes.TO_CONFIRM,
  OfferStatusTypes.TOUROPERATOR_COMMUNICATION_ERROR,
];

export const isAvailableStatus = (
  status: OfferStatusTypes | undefined
): boolean => !!status && availableStatuses.includes(status);
